const localhostString = 'localhost';

/**
 * Возвращает домен для cookies
 * @param {string} строка с доменом `window.location.hostname`
 */
export function getDomainForCookies(url: string) {
    const [_1st, _2nd] = url.split('.').reverse();

    if (_1st === localhostString) return localhostString;

    return `.${_2nd}.${_1st}`;
}
